module.exports = __webpack_public_path__ + "static/img/activity4.1b2d913.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4.png
// module id = Euuz
// module chunks = 7